import { Button, Statistic, Table } from "antd";
import { useEffect, useState } from "react";
import { createSearchParams, Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../common/api";

const getPath = (taskDefinitionKey) =>
    ({
        evaluateTask: "leaveRequestsToBeEvaluated",
        storeAbsencesTask: "leaveRequestsToBeStored",
    })[taskDefinitionKey];
export default function () {
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    const columns = [
        {
            title: "ID Attività",
            key: ["variables", "id"],
            dataIndex: "id",
            width: 350,
        },
        {
            title: "Tipologia attività",
            dataIndex: "taskDefinitionKey",
            width: 250,
            render: (x) =>
                ({
                    evaluateTask: "Approvazione ferie/permessi",
                    storeAbsencesTask: "Inserimento ferie/permessi approvati",
                })[x],
        },
        {
            title: "Dipendente",
            key: "employee",
            dataIndex: ["variables", "employee"],
            width: 150,
            render: (x) => x.lastName + " " + x.firstName,
        },
        {
            key: "actions",
            width: 100,
            render: (x) => (
                <Button
                    onClick={() =>
                        navigate({
                            pathname: getPath(x.taskDefinitionKey) + "/" + x.processInstanceId,
                            search: createSearchParams({ goBack: true }).toString(),
                        })
                    }
                    type="primary"
                >
                    Gestisci
                </Button>
            ),
        },
    ];
    useEffect(() => {
        axiosInstance.get("leaveRequest/tasks").then(({ data }) => setData(data.data));
    }, []);

    return (
            <Table
                size="small"
                dataSource={data.map((x) => ({ ...x, key: x.id }))}
                columns={columns}
                tableLayout="fixed"
                scroll={{ x: columns.reduce((acc, x) => x.width + acc, 0) }}
            ></Table>
    );
}
